import { isFunction } from "@ciaopeople/cp-shatsu/TypeChecking"
import { MediaLoadedEvent } from "../../events/PlayerEvent.js";
import { isMediaMetaData, YM_Category } from "../../../model/MediaMetaData.js";

export type NielsenTrackingIdMapping = {
    default: string,
    categorized?: {[k in YM_Category]: string}
}


 
type NielsenCmd = "setPlayheadPosition" | "stop" | "loadMetadata" | "end"


type NielsenAirDate = string

type NielsenMetadataPlayload = {
    type: "content",
    assetid: string,
    program: string,
    title: string,
    length: number,
    airdate: NielsenAirDate,
    isfullepisode: "y" | "n",
    adloadtype: "2" //what are the possible values?

}

interface NielsenSdk {

    ggPM(cmd: NielsenCmd, data: number | NielsenMetadataPlayload): void
}

interface WithNLSQueue {

    NOLBUNDLE: {
        nlsQ(e: string,o: string,c?: any,r?: any,s?: any,i?: any): NielsenSdk
    }
}

function isWithNLSQueue(x: any): x is WithNLSQueue {
    return x && "NOLBUNDLE" in x && x.NOLBUNDLE && 
            ("nlsQ" in x.NOLBUNDLE) && isFunction(x.NOLBUNDLE.nlsQ);
}



function initNLSQueue(w: Window): WithNLSQueue {
    if(isWithNLSQueue(w)) return w;
    else {
        const q = function(t,n)
        {
            t[n]=t[n]||
                {
                    nlsQ:function(e,o,c,r,s,i)
                    {
                        return s=t.document,
                            r=s.createElement("script"),
                            //r.async=1,
                            r.defer = 1,
                            r.src=("http:"===t.location.protocol?"http:":"https:")+"//cdn-gl.imrworldwide.com/conf/"+e+".js#name="+o+"&ns="+n,
                            i=s.getElementsByTagName("script")[0],
                            i.parentNode.insertBefore(r,i),
                            t[n][o]=t[n][o]||{g:c||{},
                                    ggPM:function(e,c,r,s,i){(t[n][o].q=t[n][o].q||[]).push([e,c,r,s,i])}},t[n][o]
                    }
                }
        };
        q(w,"NOLBUNDLE");
        return w as unknown as WithNLSQueue;
    }


}


export class NielsenCollectorFactory {


    

    constructor(private window: Window,
                private trackingIdMapping: NielsenTrackingIdMapping,
                private playerName: string
                ) {

    }



    public getCollector(mle: MediaLoadedEvent): NielsenCollector {
        const trackinId = mle.info.meta?.category && this.trackingIdMapping.categorized &&
            (mle.info.meta.category in this.trackingIdMapping.categorized)?
                this.trackingIdMapping.categorized[mle.info.meta.category]:
                this.trackingIdMapping.default;
        return new NielsenCollector(initNLSQueue(this.window).NOLBUNDLE.nlsQ(trackinId,this.playerName),mle);
    }

   


}

function tc(num: number): string {
    return Math.floor(num).toString().padStart(2,'0');
}

function dateToAirDate(d: Date): string {
    return `${d.getUTCFullYear()}${tc(d.getUTCMonth()+1)}${tc(d.getUTCDate())} ${tc(d.getUTCHours())}:${tc(d.getUTCMinutes())}:${tc(d.getUTCSeconds())}`;
}



const COLLECTOR_RESOLUTION_IN_SECONDS = 1;



type NielsenCollectorState =  "init" | "started" | "paused" | "ended";
/**
 * actually, as for main site and older player nielsen is not subject to gdpr
 */
export class NielsenCollector {



    private enabled: boolean;
    private state: NielsenCollectorState;
    
    private meta: NielsenMetadataPlayload;
    private lastPushedTime: number;
    
    constructor(private sdk: NielsenSdk, 
                private mle: MediaLoadedEvent
               ) {
        this.lastPushedTime = 0;
        this.state = "init";
        
        if(sdk && mle.info.meta && isMediaMetaData(mle.info.meta)) {
            const duration = mle.metadata?.duration?mle.metadata.duration:(mle.info.meta?.duration?mle.info.meta?.duration:0);
            this.enabled = true;
            console.log("VIDEOMETA",this.mle.info.meta);
            this.meta = {
                type: "content",
                assetid: this.mle.info.id,
                program: this.mle.info.title.substring(0,100),
                title: this.mle.info.title.substring(0,100),
                length: Math.floor(duration),
                airdate: dateToAirDate(new Date(this.mle.info.meta.publish_stamp?this.mle.info.meta.publish_stamp:0)),
                isfullepisode: "y",
                adloadtype: "2"

            }
        }
        else {
            this.enabled = false;
            this.meta = null;
            console.log("NIELSEN not enabled on item", this.mle.info.id, "missing meta");
        }
    }


    public timeupdate(time: number): void {
        if(this.enabled && this.state == "started") {
            const sanitime = Math.floor(time);
            if(sanitime - this.lastPushedTime >= COLLECTOR_RESOLUTION_IN_SECONDS) {
                this.lastPushedTime = sanitime;
                this.sdk.ggPM("setPlayheadPosition",sanitime)
            }
        
        }
    }


    public play(): void {
        if(this.enabled && (this.state == "init" || this.state == "paused")) {
            this.state = "started";
            this.sdk.ggPM("loadMetadata", this.meta);
        }
    }


    public pause(): void {
        if(this.enabled && this.state == "started") {
            this.state = "paused";
            this.sdk.ggPM("stop",this.lastPushedTime)
        }
    }

    public complete(): void {
        if(this.enabled && (this.state == "started" || this.state == "paused")) {
            this.state = "ended";
            this.sdk.ggPM("end",this.lastPushedTime);
        }
    }


    get currentState(): NielsenCollectorState {
        return this.state;
    }

}